import { render } from "./BlockedProfile.vue?vue&type=template&id=1e05d79d"
import script from "./BlockedProfile.vue?vue&type=script&lang=js"
export * from "./BlockedProfile.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__